import React, { FC } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  padding: 5rem 10vw 5rem;
`

export const Html: FC<any> = ({ html }) => <Container dangerouslySetInnerHTML={{ __html: html || '' }} />
